export default class FocusAreasStrategy {


	// Constructor
	constructor(element) {

		this.images = Array.prototype.slice.call(element.querySelectorAll('.section-focus-areas-strategy--img'), 0);
		this.links = Array.prototype.slice.call(element.querySelectorAll('.section-focus-areas-strategy--item a'), 0);

		this.mouseOver = this.mouseOver.bind(this);
		this.mouseOut = this.mouseOut.bind(this);

		for (var i=0, l=this.links.length; i<l; i++) {
			this.links[i].addEventListener('mouseover', this.mouseOver);
			this.links[i].addEventListener('mouseout', this.mouseOut);
		}

	}


	// Event Handlers
	mouseOver(event) {
		const index = this.links.indexOf(event.currentTarget);
		this.images[index].classList.add('active');
	}
	mouseOut(event) {
		const index = this.links.indexOf(event.currentTarget);
		this.images[index].classList.remove('active');
	}


}
